import { supabase } from "./api";

export const revalidate = 0;

function getCompanyId() {
  return localStorage.getItem("companyId");
}

export async function getAllData() {
  const companyId = getCompanyId();
  const { data, error } = await supabase.from("instructorstudentview").select().eq('companyId',companyId);

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getDataWithType(type) {
  const companyId = getCompanyId();

  const { data, error } = await supabase
    .from("instructorstudentview")
    .select()
    .eq("type", type)
    .eq('companyId',companyId);

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getIdData(id) {
  const { data, error } = await supabase
    .from("instructorstudentview")
    .select()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getStudentIdData(id, cls) {
  const companyId = getCompanyId();
  const prm = `studentId.eq.${id},studentId.is.null`;
  //.or('studentId.eq.2,studentId.is.null')
  const { data, error } = await supabase
    .from("instructorstudentview")
    .select()
    //.eq('studentId', id);
    .or(prm)
    .eq("class", cls)
    .eq('companyId',companyId);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getInstructorStudent(id) {
  const companyId = getCompanyId();
  const { data, error } = await supabase
    .from("instructorstudentview")
    .select()
    .eq('isActive', true)
    .or(`instructorId.eq.${id},subinstructorId.eq.${id}`)
    .eq('companyId',companyId);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function getInstructorStudentwithClass(id, classId) {
  const companyId = getCompanyId();
  const { data, error } = await supabase
    .from("instructorstudentview")
    .select()
    .or(`instructorId.eq.${id},subinstructorId.eq.${id}`)
    .eq("classId", classId)
    .eq("isActive", true)
    .eq('companyId',companyId);

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function addData(adata) {
  const { data, error } = await supabase
    .from("instructorstudentview")
    .insert(adata)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function updateData(udata) {
  console.log("udata", udata);
  const { data, error } = await supabase
    .from("instructorstudentview")
    .update(udata)
    .eq("id", udata.id)
    .select();

  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}

export async function deleteIdData(id) {
  const { data, error } = await supabase
    .from("instructorstudentview")
    .delete()
    .eq("id", id);
  if (error) {
    throw new Error("Failed to fetch data");
  }

  return data;
}
